<template>
<div class="" style="padding-bottom: 90px;">
    <div class="bgp" style="text-align: center; text-shadow: 1px 1px 2px #333;">
        <div class="container">
            <h1 style="color: white; padding-top: 10px; padding-top: 170px;">{{ $t('cbH') }}</h1>
            <p style="color: white; padding-top: 10px;">{{ $t('cbP') }}</p>
        </div>
    </div>
    <div class="container" style="padding-top: 90px;">
         <div class="row" style="text-align: center;">
            <div class="col-xl col-md col-sm-12 mt-2" style="padding-top: 25px;">
                <div class="pad">
                    <img src="@/assets/PMS/invoice.png" style="width: 80px;" alt="">
                    <h5 style="font-weight: 500; padding-top: 40px;">{{ $t('cbIn') }}</h5>
                </div>
            </div>
            <div class="col-xl col-md col-sm-12 mt-2" style="padding-top: 25px;">
                <div class="pad">
                    <img src="@/assets/PMS/signature.png" style="width: 80px;" alt="">
                    <h5 style="font-weight: 500; padding-top: 40px;">{{ $t('cbDs') }}</h5>
                </div>
            </div>
            <div class="col-xl col-md col-sm-12 mt-2" style="padding-top: 25px;">
                <div class="pad">
                    <img src="@/assets/PMS/id.png" style="width: 80px;" alt="">
                    <h5 style="font-weight: 500; padding-top: 40px;">{{ $t('cbId') }}</h5>
                </div>
            </div>
            <div class="col-xl col-md col-sm-12 mt-2" style="padding-top: 25px;">
                <div class="pad">
                    <img src="@/assets/PMS/gear.png" style="width: 80px;" alt="">
                    <h5 style="font-weight: 500; padding-top: 40px;">{{ $t('cbWid') }}</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="container pl-0 pr-0" style="margin-top: 100px; border: 1px solid #f2f2f2;">
        <b-embed
            type="iframe"
            aspect="16by9"
            src="https://www.europrotel.com/Content/videos/proteltanitim_en.mp4"
            allowfullscreen
        ></b-embed>
    </div>
    <div class="container" style="padding-top: 100px;">
        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('cbH1') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('cbP1') }}</li>
                    <li>{{ $t('cbP2') }}</li>
                    <li>{{ $t('cbP3') }}</li>
                    <li>{{ $t('cbP4') }}</li>
                    <li>{{ $t('cbP5') }}</li>
                </ul>

            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/PMS/reservation.jpg')" v-b-modal.modal-1 src="@/assets/PMS/reservation.jpg" class="col" alt="">
            </div> 
        </div>

        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/PMS/res2.jpg')" v-b-modal.modal-1 src="@/assets/PMS/res2.jpg" class="col" alt="">
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('cbH2') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('cbP6') }}</li>
                    <li>{{ $t('cbP7') }}</li>
                    <li>{{ $t('cbP8') }}</li>
                    <li>{{ $t('cbP9') }}</li>
                    <li>{{ $t('cbP10') }}</li>
                </ul>
            </div>
        </div>

        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('cbH3') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('cbP11') }}</li>
                    <li>{{ $t('cbP12') }}</li>
                    <li>{{ $t('cbP13') }}</li>
                    <li>{{ $t('cbP14') }}</li>
                    <li>{{ $t('cbP15') }}</li>
                </ul>

            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/PMS/res3.jpg')" v-b-modal.modal-1 src="@/assets/PMS/res3.jpg" class="col" alt="">
            </div>
        </div>

        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/PMS/res4.jpg')" v-b-modal.modal-1 src="@/assets/PMS/res4.jpg" class="col" alt="">
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('cbH4') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('cbP16') }}</li>
                    <li>{{ $t('cbP17') }}</li>
                    <li>{{ $t('cbP18') }}</li>
                    <li>{{ $t('cbP19') }}</li>
                    <li>{{ $t('cbP20') }}</li>
                </ul>
            </div>
        </div>

        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('cbH5') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('cbP21') }}</li>
                    <li>{{ $t('cbP22') }}</li>
                    <li>{{ $t('cbP23') }}</li>
                    <li>{{ $t('cbP24') }}</li>
                </ul>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/PMS/res5.jpg')" v-b-modal.modal-1 src="@/assets/PMS/res5.jpg" class="col" alt="">
            </div>
        </div>

        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/PMS/res6.jpg')" v-b-modal.modal-1 src="@/assets/PMS/res6.jpg" class="col" alt="">
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('cbH6') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('cbP25') }}</li>
                    <li>{{ $t('cbP26') }}</li>
                    <li>{{ $t('cbP27') }}</li>
                    <li>{{ $t('cbP28') }}</li>
                    <li>{{ $t('cbP29') }}</li>
                </ul>
            </div>
        </div>

        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('cbH7') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('cbP30') }}</li>
                    <li>{{ $t('cbP31') }}</li>
                    <li>{{ $t('cbP32') }}</li>
                    <li>{{ $t('cbP33') }}</li>
                    <li>{{ $t('cbP34') }}</li>
                    <li>{{ $t('cbP35') }}</li>
                    <li>{{ $t('cbP36') }}</li>
                </ul>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/PMS/res7.jpg')" v-b-modal.modal-1 src="@/assets/PMS/res7.jpg" class="col" alt="">
            </div>
        </div>

        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/PMS/res8.jpg')" v-b-modal.modal-1 src="@/assets/PMS/res8.jpg" class="col" alt="">
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('cbH8') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('cbP37') }}</li>
                    <li>{{ $t('cbP38') }}</li>
                    <li>{{ $t('cbP39') }}</li>
                    <li>{{ $t('cbP40') }}</li>
                    <li>{{ $t('cbP41') }}</li>
                </ul>
            </div>
        </div>

        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('cbH9') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('cbP42') }}</li>
                    <li>{{ $t('cbP43') }}</li>
                    <li>{{ $t('cbP44') }}</li>
                    <li>{{ $t('cbP45') }}</li>
                    <li>{{ $t('cbP46') }}</li>
                    <li>{{ $t('cbP47') }}</li>
                    <li>{{ $t('cbP48') }}</li>
                </ul>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/PMS/res9.jpg')" v-b-modal.modal-1 src="@/assets/PMS/res9.jpg" class="col" alt="">
            </div>
        </div>

        <div>
            <b-modal id="modal-1" size="xl" style="" hide-footer hide-header>
                <img :src="source" class="col" alt="">
            </b-modal>
        </div>
    
    </div>
</div> 
</template>

<script>

export default {
  name: 'CloudPms',
  data(){
    return{
       source: require('@/assets/PMS/res9.jpg'),
    }
  },
  async mounted(){
  },

  methods : {
      
  },

  components: {

  },
  props: {

  },
      
 computed: {
  },
}

</script>

<style scoped>
.bgp{
background-image: url("../../assets/att.jpg");
background-size: cover;
height: 400px;
}
.center {
margin-left: 45%;
padding-top: 200px;
color: white;
}
.underline {
  color: black;
  display: inline-block;
  font-size: 0.875rem;
  padding-bottom:2px;
  background-image: linear-gradient(red, red);
  background-position: 0 100%; /*OR bottom left*/
  background-size: 0% 2px;
  background-repeat: no-repeat;
  transition:
  background-size 0.3s,
  background-position 0s 0.3s; /*change after the size immediately*/
}
.underline:hover {
 background-position: 100% 100%; /*OR bottom right*/
  background-size: 100% 2px;
}

.pad{
    background: #f7f9fc;; 
    padding: 40px; 
    border-radius: 5px; 
    height: 255px;
}

.pad:hover{
    margin-top: -5px !important;
    transition: 350ms;
    box-shadow: 0px 10px 20px 2px #bbb8b8;
}


</style>
